import { render, staticRenderFns } from "./BPaginationNavCustom.vue?vue&type=template&id=791c7654&scoped=true"
import script from "./BPaginationNavCustom.vue?vue&type=script&lang=js"
export * from "./BPaginationNavCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791c7654",
  null
  
)

export default component.exports